import { Component } from "@angular/core";

@Component({
    selector: "app-ee-privacy-terms",
    templateUrl: "./ee-privacy-terms.component.html",
    styleUrls: ["./ee-privacy-terms.component.scss"],
    standalone: false
})
export class EePrivacyTermsComponent {}
